import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/auth/login/login.component').then(
        (c) => c.LoginComponent
      ),
  },
  {
    path: 'signup',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/auth/signup/signup.component').then(
        (c) => c.SignupComponent
      ),
  },
  {
    path: 'signup/:type?',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/auth/signup/signup.component').then(
        (c) => c.SignupComponent
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password.component').then(
        (c) => c.ForgotPasswordComponent
      ),
  },
  {
    path: 'reset-password/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password.component').then(
        (c) => c.ForgotPasswordComponent
      ),
  },
  {
    path: 'business-profile',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/business-profile/business-profile.component').then(
        (c) => c.BusinessProfileComponent
      ),
  },
  {
    path: 'billing-and-payments',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/billing-and-payment/billing-and-payment.component').then(
        (c) => c.BillingAndPaymentComponent
      ),
  },
  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/home/home.component').then(
        (c) => c.HomeComponent
      ),
  },
  {
    path: 'link-account',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/link-account/link-account.component').then(
        (c) => c.LinkAccountComponent
      ),
  },
  {
    path: 'wa',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/whatsapp/wa.module').then((m) => m.WaModule),
  },
  {
    path: 'fb',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/facebook/fb.module').then((m) => m.FbModule),
  },
  {
    path: 'va',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/voice-agent/voice-agent.module').then((m) => m.VoiceAgentModule),
  },
  { path: '**', redirectTo: 'signin' },
];
